import React, {Component} from 'react';
import XeniagraphyList from "./xeniagraphyList";
import config from '../config.json';
import MultiselectDropdown from "./multiselect_dropdown_option";
import Select from 'react-select'
import WebviewModal from "./webview_modal";
import {AiFillCloseSquare} from "react-icons/all";


const groupStyles = {
    display: 'flex',
    alignItems: 'left',
    textAlign: 'left',
    justifyContent: 'space-between',
};

const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'left',
    justifyContent: 'left',
    alignItems: 'left'
};

const indicatorFilterOptions = [
    {
        label: `Date de qualification`,
        value: 'dateCreated'
    },
    {
        label: 'Ressenti Relationnel',
        value: 'hasRelationalPerceptionScore'
    },
    {
        label: 'Intensité des désirs',
        value: 'hasEmotionalIntensityScore'
    },
    {
        label: "Nature de désir",
        options: [
            {
                label: ' - Réveiller I\'enfant en soi',
                value: 'hasRegagnerLinsouciancePw'
            },
            {
                label: ' - Tenter I\'nconnu',
                value: 'hasSouvrirAlEtrangePw'
            },
            {
                label: ' - Habiter I\'nstant',
                value: 'hasHabiterLinstantPw'
            },
            {
                label: ' - Ressentir la fonction poétique',
                value: 'hasTransfigurerLeReelPw'
            },
            {
                label: ' - Éprouver le sens de l\'existence',
                value: 'hasSaluerLeMysterePw'
            },
        ]
    },
];

class LandingPage extends Component {


    constructor(props) {

        super(props);
        this.state = {
            masterSubjects: [],
            youtubeUrl: null,
            widgetContextLink: null,
            widgetLink: null,
            customerUri: null,
            masterSubjectCount: null,
            xeniawaysCount: null,
            families: [],
            selectedFamilies: [],
            direction: 'DESC',
            sortField: 'dateCreated',
            isModalOpen: false,
            page: 0,
            pageSize: 10,
            iframeSrc: '',
            xeniawaysOn: false,
            widgetMetrics: null,
            showPagination: true
        };
        this.loadNext = this.loadNext.bind(this);
        this.openWebViewModal = this.openWebViewModal.bind(this);
        this.closeWebViewModal = this.closeWebViewModal.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.receiveMessage, false);
        this.fetchSettings();
    }

    componentWillUnmount() {
        window.removeEventListener("message" , this.receiveMessage);
    }

    receiveMessage = (event) => {
        const message = event.data.message;
        switch (message) {
            case 'getSubjectMetrics':
                this.setWidgetMetrics(event.data.value);
                break;
            case 'closeModal':
                this.closeWebViewModal();
                break;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.page !== this.state.page){
            this.fetchNext();
        }
    }

    handleFamilyChange = (selected) => {
        const families = selected.map( fam => fam.uri);
        this.setState({
            selectedFamilies: families,
            page: 0
        })
        setTimeout( ()=> {
            this.fetchData();
        } , 100);
    };

    handleSortChange = (selected) => {
        this.setState({
            sortField: selected.value,
            xeniawaysOn: false,
            widgetMetrics: null
        })
        setTimeout( ()=> {
            this.fetchData();
        } , 100);
    }

    fetchFamilies  = () => {
        console.log('fetching families...')
        fetch(config.serverUrl_local + `/public/get-families?customerUri=${encodeURIComponent(this.state.customerUri)}`)
            .then(async response => {
                const data = await response.json();

                // check for error response
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }

                let fams = [];
                for (let family of data){
                    family['value'] = family.uri;
                    family['label'] = family.name;
                    fams.push(family);
                }
                console.log(fams);
                this.setState({
                    families: fams
                })
            })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    fetchNext = () => {
        fetch(config.serverUrl_local + `/public/getLatestMasterSubjects` ,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customerUri: this.state.customerUri,
                    familyUris: this.state.selectedFamilies,
                    direction: this.state.direction,
                    sortField: this.state.sortField,
                    page: this.state.page,
                    pageSize: this.state.pageSize
                })
            }).then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
                // get error message from body or default to response statusText
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }

            console.log('data ', data);
            const currentData = this.state.masterSubjects;
            const result = currentData.concat(data.latestMasterSubjects.content);
            this.setState({
                masterSubjects: result,
                showPagination: !data.latestMasterSubjects.last
            })
        }).catch(error => {
            this.setState({errorMessage: error.toString()});
            console.error('There was an error!', error);
        });
    }

    fetchData = () => {
        console.log('fetching data' , this.state.sortField)
        fetch(config.serverUrl_local + `/public/getLatestMasterSubjects` ,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customerUri: this.state.customerUri,
                    familyUris: this.state.selectedFamilies,
                    direction: this.state.direction,
                    sortField: this.state.sortField,
                    page: this.state.page,
                    pageSize: this.state.pageSize,
                    widgetMetrics: this.state.widgetMetrics,
                    xeniawaysOn: this.state.xeniawaysOn
                })
            }).then(async response => {
            const data = await response.json();
            // check for error response
            if (!response.ok) {
                // get error message from body or default to response statusText
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }

            console.log('get request result' , data);
            this.setState({
                xeniawaysCount: data.xeniawaysCount,
                masterSubjectCount: data.masterSubjectCount,
                masterSubjects: data.latestMasterSubjects.content,
                showPagination: !data.latestMasterSubjects.last
            })
        })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    fetchSettings = () => {
        fetch(config.serverUrl_local + '/public/collab')
            .then(async response => {
                console.log('collab config response', response)
                const data = await response.json();

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response statusText
                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }

                console.log('collab data ', data);
                window.widgetContextLink = data.widgetContextLink;
                this.setState({
                    youtubeUrl: data.youtubeUrl,
                    widgetLink: data.widgetLink,
                    widgetContextLink: data.widgetContextLink,
                    customerUri: data.customerUri
                })
            }).then(() => {
            this.fetchData(this.state.customerUri);
            this.fetchFamilies()
        })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    openLinkInNewTab(url) {
        if (url == null) {
            return false;
        }
        window.open(url, "_blank")
    }

    openXeniaways(iframeSrc,modalTitle){
        document.body.style.overflowY = 'hidden';
        console.log('iframeSrc - > ' + iframeSrc)
        this.setState({
            modalTitle: modalTitle,
            isModalOpen: true,
            iframeSrc: iframeSrc + '?fromPortal=true',
            xeniawaysOn: true
        })
    }

    openWebViewModal(iframeSrc,modalTitle,websiteUrl,familyUri){
        document.body.style.overflowY = 'hidden';
        console.log('iframeSrc - > ' + iframeSrc)
        this.setState({
            isModalOpen: true,
            iframeSrc: iframeSrc + '?fromPortal=true&widgetContextLink='+websiteUrl+'&familyUri='+familyUri,
            modalTitle: modalTitle
        })

    }

    closeWebViewModal(){
        document.body.style.overflowY = 'scroll';
        this.setState({
            isModalOpen: false,
            iframeSrc: '',
            xeniawaysOn: (this.state.xeniawaysOn && this.state.widgetMetrics != null)
        })
        if(this.state.modalTitle==="Ajouter une expérience vécue" || this.state.modalTitle==="Requalifier l'objet"){
            setTimeout( ()=> {
                this.fetchData();
            } , 30);
        }
    }

    loadNext(a){
        this.setState({
            page: this.state.page + 1
        })
    }

    setWidgetMetrics = (metrics) => {
        this.setState({
            xeniawaysOn: true,
            widgetMetrics: metrics
        })
        setTimeout( () => {
            this.fetchData();
        } , 30);
    }

    handleXeniawaysChange = ( check ) => {
        if (check){
            if (this.state.widgetMetrics === null){
                this.openWebViewModal(this.state.widgetLink);
            }else{
                setTimeout( ()=> {
                    this.fetchData();
                } , 30);
            }
            this.setState({xeniawaysOn: check})
        }else{
            this.setState({
                xeniawaysOn: check
            })
            setTimeout( ()=> {
                this.fetchData();
            } , 30);
        }
    }

    formatGroupLabel = (data) => {
        return ( <div style={groupStyles}>
            <span style={{textAlign: 'left'}}>{data.label}</span>
            <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>);
    }

    render() {
        return (
            <>
                <WebviewModal show={this.state.isModalOpen && this.state.iframeSrc !== ''} handleClose={this.closeWebViewModal}>
                    <div className="close-modal-title">

                        <div className="float-left">
                            <div className="xenia-modal-title">{this.state.modalTitle}</div>
                        </div>
                        <div className="float-right">
                            <AiFillCloseSquare onClick={ ()=> this.closeWebViewModal()} className="close-icon"/>
                        </div>
                    </div>
                    <div className="col-md-12 s_margin30">
                        {this.state.iframeSrc !== '' ? <div className="templatemo_home_midmid" id="embeded_iframe">
                            <embed className="embeded_iframe_modal" style={{"height": window.innerHeight - 110,"width" : "100%"}}
                                   src={this.state.iframeSrc}/>
                        </div> : null}
                    </div>
                </WebviewModal>
                <div className="container menu">
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="templatemo_webtitle"><img
                                src="https://xenia-app.laleph.com/portail-vin/static/media/logoxenia.caff7453.png" alt="logo"/></div>
                        </div>
                        <div className="col-sm-8">
                            <nav className="navbar navbar-default" role="navigation">
                                <div className="container-fluid">
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="templatemo_home_top">
                            <div className="col-md-12">
                                <div className="templatemo_home_top_left ">
                                    <div className="templatemo_hometop_stitle">
                                        Bienvenue !<br />
                                        Découvrez les expériences qualifiées émotionnellement par d’autres que vous.<br />
                                        Recherchez celles qui répondent le mieux à vos désirs du moment.<br />
                                        Et, vous aussi, jouez et ajoutez à la liste les expériences que vous avez aimées. Une façon inédite de faire la promotion de ce qui contribue à votre bien-être et votre bonheur !<br /><br />
                                        Ici, pas de notes ni de petites étoiles… Chaque expérience, vécue comme un voyage, est appréciée par le climat émotionnel qu’elle engendre.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="container">
                        <div className="row filter-wrapper">
                            <div className="col-sm-4 col-md-4 col-lg-4 ">
                                <div className="filter-info">Expériences partagées: {this.state.masterSubjectCount}</div>
                            </div>
                            <div className="add-widget col-sm-4 col-md-4 col-lg-4 ">
                                <div id="ajouter_experience" className="templatemo_buttongreen" title="Qualifier une expérience que vous avez aimée et l’ajouter à la liste des expériences partagées." onClick={() => this.openWebViewModal(this.state.widgetContextLink,"Ajouter une expérience vécue","","")}>Ajouter une expérience vécue</div>
                            </div>
                        </div>
                        <div className="row filter-wrapper ">
                            <div className="col-sm-4 col-md-4 col-lg-4 ">
                                <MultiselectDropdown id="categories_select"
                                    title="Catégories"
                                    options={this.state.families}
                                    onSelectionChange={this.handleFamilyChange}
                                />
                            </div>
                            <div className="col-sm-4 col-md-4 col-lg-4 ">
                                <h4 className="filter-header">Trier par</h4>
                                <Select  id="filter_select"
                                    onChange={(e)=> this.handleSortChange(e)}
                                    formatGroupLabel={this.formatGroupLabel}
                                    options={indicatorFilterOptions}
                                />

                            </div>
                            <div className="col-sm-1 col-md-1 col-lg-1 ">
                                <div>ou</div>
                            </div>
                            <div className="col-sm-3 col-md-3 col-lg-3 ">
                                <div className="xeniaways_button">
                                    <a href="#">
                                        <div id="mes_desirs" title="Exprimer mes désirs pour obtenir le tri des expériences à vivre par distance émotionnelle." className="templatemo_buttongreen" onClick={(e) => {
                                            e.preventDefault();
                                            this.openXeniaways(this.state.widgetLink,"Mes désirs");
                                        }}>Mes désirs
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <XeniagraphyList masterSubjects={this.state.masterSubjects}
                                     masterSubjectCount={this.state.masterSubjectCount}
                                     xeniawaysCount={this.state.xeniawaysCount}
                                     openWebViewModal={this.openWebViewModal}
                                     loadNext={this.loadNext}
                                     widgetContextLink={this.state.widgetContextLink}
                                     showDistance={this.state.xeniawaysOn}
                                     showPagination={this.state.showPagination}
                    />
                    <div className="container">
                        <div className="row">
                            <a className="btn btn-link footer-global" target="_blank" href="https://www.laleph.com/mentions-legales/">Mentions légales</a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default LandingPage;